// @flow @jsx h

import { h } from 'preact'
import styles from './WhaleCaption.css'
import { bem } from '@nrk/dh-utils'
import { result, caption } from '../../config/text'
import { TIERS } from '../../constants/'

import type { Answers } from '../../types'

const { TIER_ONE } = TIERS

type Props = {
  isVisible: boolean,
  isCorrect: boolean,
  isResultView: boolean,
  answers: Answers,
  currentTier: string
}

const WhaleCaption = ({
  isCorrect,
  isVisible,
  isResultView,
  answers,
  currentTier
}: Props) => {
  let text = isCorrect ? caption.correct : caption.wrong
  if (isResultView) {
    const { whaleCaption } = result[currentTier]
    text = whaleCaption
  }
  return (
    <div class={styles['whale-caption__wrapper']}>
      <div
        class={bem(styles['whale-caption'], {
          visible: currentTier !== TIER_ONE && isVisible
        })}
      >
        <span class={styles['whale-caption__text']}>{text}</span>
      </div>
    </div>
  )
}

export { WhaleCaption }



// WEBPACK FOOTER //
// ./src/v1/components/Background/WhaleCaption.js